import React from 'react';
import '../styles/main.scss';
import { NomineeDetailsModel } from '../models/NomineeDetails';
import { BasicDetailsModel } from '../models/BasicDetails';

interface NomineeDetailsProps {
  data?: NomineeDetailsModel;
  basicDetails?: BasicDetailsModel;
  onSubmit: (data: NomineeDetailsModel) => void;
  onBack: () => void;
}

type NomineeDetailsState = NomineeDetailsModel & { sameAsApplicant?: boolean };

class NomineeDetails extends React.Component<NomineeDetailsProps, NomineeDetailsState> {
  constructor(props: NomineeDetailsProps) {
    super(props);
    this.state = props.data || {
      nomineeName: '',
      relationship: '',
      nomineeDob: '',
      nomineeAge: 0,
      nomineeAdhaar: '',
      nomineePan: '',
      nomineeMobile: '',
      nomineeGender: '',
      nomineeAddress: '',
      nomineeCity: '',
      nomineeState: '',
      nomineePincode: '',
      GaurdianName: '',
      isminor: false,
      sameAsApplicant: false
    };
  }

  handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, type } = e.target as HTMLInputElement;
    let value: any = (e.target as HTMLInputElement).value;
    if (type === 'checkbox') {
      value = (e.target as HTMLInputElement).checked;
    }

    this.setState(prev => {
      const nextState: any = { ...prev, [name]: value };
      // If DOB changed, compute age
      if (name === 'nomineeDob') {
        const dob = value;
        if (dob) {
          const birth = new Date(dob);
          const today = new Date();
          let age = today.getFullYear() - birth.getFullYear();
          const m = today.getMonth() - birth.getMonth();
          if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
            age--;
          }
          nextState.nomineeAge = age;
          // auto mark minor if age < 18
          if (age < 18) nextState.isminor = true;
        } else {
          nextState.nomineeAge = 0;
        }
      }

      // If sameAsApplicant checkbox toggled, copy applicant address fields
      if (name === 'sameAsApplicant') {
        if (value && this.props.basicDetails) {
          nextState.nomineeAddress = this.props.basicDetails.Address || '';
          nextState.nomineeCity = this.props.basicDetails.City || '';
          nextState.nomineeState = this.props.basicDetails.State || '';
          nextState.nomineePincode = this.props.basicDetails.Pincode || '';
        }
      }

      return nextState;
    });
  };

  handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // validation: if minor, guardian name required
    if ((this.state as any).isminor && !(this.state as any).GaurdianName) {
      alert('કૃપા કરીને ગાર્ડિયનનું નામ દર્શાવો (Guardian name is required for minors).');
      return;
    }
    this.props.onSubmit(this.state);
  };

  render() {
    const {
      nomineeName,
      relationship,
      nomineeDob,
      nomineeAge,
      nomineeAdhaar,
      nomineePan,
      nomineeMobile,
      nomineeGender,
      nomineeAddress,
      nomineeCity,
      nomineeState,
      nomineePincode,
      GaurdianName,
      isminor,
      sameAsApplicant
    } = this.state;

    return (
      <div className="registration-container">
        <h2 className="form-heading">વારસદારની વિગતો</h2>
        <form className="form-grid" onSubmit={this.handleSubmit}>
          <div>
            <label className="text-muted">વારસદારનું પૂરુ નામ</label>
            <input
              type="text"
              name="nomineeName"
              value={nomineeName}
              onChange={this.handleChange}
              placeholder="વારસદારનું નામ લખો"
              required
            />
          </div>

          <div>
            <label className="text-muted">સંબંધ</label>
            <select name="relationship" value={relationship} onChange={this.handleChange} required>
              <option value="">પસંદ કરો</option>
              <option value="spouse">પતિ/પત્ની</option>
              <option value="child">પુત્ર/પુત્રી</option>
              <option value="parent">માતા/પિતા</option>
              <option value="sibling">ભાઈ/બહેન</option>
              <option value="other">અન્ય</option>
            </select>
          </div>

          <div>
            <label className="text-muted">જન્મ તારીખ</label>
            <input type="date" name="nomineeDob" value={nomineeDob} onChange={this.handleChange} required />
          </div>

          <div>
            <label className="text-muted">ઉમર</label>
            <input type="number" name="nomineeAge" value={nomineeAge} onChange={this.handleChange} min={0} />
          </div>

          <div className="checkbox-group">
            <input type="checkbox" id="isminor" name="isminor" checked={isminor} onChange={this.handleChange} disabled={nomineeAge < 18} />
            <label htmlFor="isminor" className="text-muted">નાનું છે (Minor)</label>
          </div>

          {isminor && (
            <div>
              <label className="text-muted">ગાર્ડિયનનું નામ</label>
                <input type="text" name="GaurdianName" value={GaurdianName} onChange={this.handleChange} required={isminor} />
            </div>
          )}

          <div>
            <label className="text-muted">લિંગ</label>
            <select name="nomineeGender" value={nomineeGender} onChange={this.handleChange}>
              <option value="">પસંદ કરો</option>
              <option value="male">પુરુષ</option>
              <option value="female">સ્ત્રી</option>
              <option value="other">અન્ય</option>
            </select>
          </div>

          <div>
            <label className="text-muted">આધાર નંબર</label>
            <input type="text" name="nomineeAdhaar" value={nomineeAdhaar} onChange={this.handleChange} placeholder="12 અંક" pattern="[0-9]{12}" />
          </div>

          <div>
            <label className="text-muted">PAN</label>
            <input type="text" name="nomineePan" value={nomineePan} onChange={this.handleChange} placeholder="PAN" />
          </div>

          <div>
            <label className="text-muted">મોબાઈલ નંબર</label>
            <input type="tel" name="nomineeMobile" value={nomineeMobile} onChange={this.handleChange} placeholder="10 અંકનો મોબાઈલ નંબર" pattern="[0-9]{10}" required />
          </div>

          <div className="checkbox-group">
            <input type="checkbox" id="sameAsApplicant" name="sameAsApplicant" checked={sameAsApplicant} onChange={this.handleChange} />
            <label htmlFor="sameAsApplicant" className="text-muted">સરનામું અરજીકર્તા જેવું જ</label>
          </div>
          
          <div>
            <label className="text-muted">સરનામું</label>
            <textarea name="nomineeAddress" value={nomineeAddress} onChange={this.handleChange} disabled={sameAsApplicant} />
          </div>

          <div>
            <label className="text-muted">શહેર</label>
            <input type="text" name="nomineeCity" value={nomineeCity} onChange={this.handleChange} disabled={sameAsApplicant} />
          </div>

          <div>
            <label className="text-muted">રાજ્ય</label>
            <input type="text" name="nomineeState" value={nomineeState} onChange={this.handleChange} disabled={sameAsApplicant} />
          </div>

          <div>
            <label className="text-muted">પિનકોડ</label>
            <input type="text" name="nomineePincode" value={nomineePincode} onChange={this.handleChange} disabled={sameAsApplicant} />
          </div>

          <div className="button-group">
            <button type="button" onClick={this.props.onBack} className="form-btn secondary">
              પાછા
            </button>
            <button type="submit" className="form-btn">
              આગળ વધો
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default NomineeDetails;